export const SITE_URL = "https://kaizen.co.ke";
export const SITE_TITLE = "Kaizen — Goal Tracking & Group Accountability";
export const SITE_DESCRIPTION =
  "Build consistency with Kaizen. Track goals, declare daily commitments, share evidence of your work, and review progress with your private accountability group.";
